// START --> To add custom class to Tooltip used in DomIntl Switch to make it exclusive; Ref: https://stackoverflow.com/questions/13160357/adding-custom-class-to-tooltip
;(function($) {

    if (typeof $.fn.tooltip.Constructor === 'undefined') {
        throw new Error('Bootstrap Tooltip must be included first!');
    }

    var Tooltip = $.fn.tooltip.Constructor;

    // add customClass option to Bootstrap Tooltip
    $.extend( Tooltip.Default, {
        customClass: ''
    });

    var _show = Tooltip.prototype.show;

    Tooltip.prototype.show = function () {

        // invoke parent method
        _show.apply(this,Array.prototype.slice.apply(arguments));

        if ( this.config.customClass ) {
            var tip = this.getTipElement();
            $(tip).addClass(this.config.customClass);
        }

    };

})(window.jQuery);
// END <-- To add custom class to Tooltip used in DomIntl Switch to make it exclusive; Ref: https://stackoverflow.com/questions/13160357/adding-custom-class-to-tooltip